import { render, staticRenderFns } from "./projectCanten.vue?vue&type=template&id=da70ff3e&scoped=true&"
import script from "./projectCanten.vue?vue&type=script&lang=js&"
export * from "./projectCanten.vue?vue&type=script&lang=js&"
import style0 from "./projectCanten.vue?vue&type=style&index=0&id=da70ff3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da70ff3e",
  null
  
)

export default component.exports